import React from "react";
import { AlertDescriptionVariantProps } from "../../@types";
import { classificationByValues } from "../../../../lib/enums/ThreatStatusEnum";
import { SampleDetailsLink } from "../../../../components";

const AlertDescriptionSampleDownload = ({
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionVariantProps) => (
  <>
    Sample{" "}
    <SampleDetailsLink
      sampleRecord={{
        filename: data.sha1,
        sha1: data.sha1,
        threat_status: data.threat_status,
        classification: classificationByValues[data.threat_status].toLowerCase()
      }}
      reloadDocument={linksReloadDocument}
      onClick={onLinkClick}
    />{" "}
    available for download.
  </>
);

export default AlertDescriptionSampleDownload;
